import { atom } from 'recoil';


const imageDroppingState = atom({
    key: 'imageDrop',
    default: false,
});


export { imageDroppingState } 